import React, { memo } from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😰',
  title: 'Llega un paciente inestable y dudás del manejo inicial',
  description: 'Sin un sistema de triage claro o TEP automatizado para evaluar la gravedad en segundos.'
}, {
  emoji: '📋',
  title: 'Documentás a las apuradas sin saber si te protege',
  description: 'Sin plantillas adaptadas a la guardia pediátrica que te blinden ante un alta voluntaria o complicación.'
}, {
  emoji: '🫁',
  title: 'Dudás en los criterios de internación respiratoria',
  description: 'Bronquiolitis, asma, neumonía: riesgo de derivación tardía o internación innecesaria.'
}, {
  emoji: '🌡️',
  title: 'El lactante febril menor de 3 meses te genera ansiedad',
  description: 'Fiebre sin foco, sepsis, meningitis: exposición a complicaciones graves por manejo empírico.'
}, {
  emoji: '🧠',
  title: 'Convulsión en la guardia y el tiempo corre',
  description: 'Estrés y demoras en la medicación por no tener un protocolo paso a paso memorizado.'
}, {
  emoji: '💬',
  title: 'Los padres exigen antibióticos o estudios innecesarios',
  description: 'Cedes ante la presión a las 3 AM por falta de herramientas de comunicación asertiva.'
}, {
  emoji: '🚨',
  title: 'Tu documentación no refleja la gravedad real',
  description: 'Si algo sale mal, tu historia clínica de guardia no demuestra que actuaste correctamente.'
}, {
  emoji: '💧',
  title: 'Dudás entre hidratación oral o endovenosa',
  description: 'Dudas constantes en la gradación de la deshidratación y el manejo digestivo agudo.'
}];
export function PainPoints() {
  return <section className="bg-slate-100 py-8 sm:py-28" data-id="element-225">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-226">
        <div className="text-center max-w-3xl mx-auto mb-6 sm:mb-16" data-id="element-227">
          <h2 className="text-[10px] sm:text-sm font-semibold tracking-wide text-slate-500 uppercase mb-1.5 sm:mb-3" data-id="element-228">
            REALIDAD DE LA GUARDIA PEDIÁTRICA
          </h2>
          <p className="text-xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-2 sm:mb-4" data-id="element-229">
            ¿TE PASA ESTO?
          </p>
          <p className="text-xs sm:text-lg text-slate-600" data-id="element-230">
            Si hacés guardias o atendés urgencias en Argentina, esto te suena
            familiar:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-6 mb-6 sm:mb-16" data-id="element-231">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} whileHover={{
          y: -5,
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="bg-white rounded-xl sm:rounded-2xl p-3 sm:p-6 shadow-sm ring-1 ring-slate-200/60 hover:shadow-lg hover:ring-blue-200 transition-all cursor-pointer flex sm:block items-start gap-3 sm:gap-0" data-id="element-232">
              <div className="text-xl sm:text-3xl mb-0 sm:mb-4 flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-233">
                {point.emoji}
              </div>
              <div data-id="element-234">
                <h3 className="text-xs sm:text-lg font-semibold text-slate-900 mb-1 sm:mb-2 leading-snug" data-id="element-235">
                  {point.title}
                </h3>
                <p className="text-slate-600 text-[10px] sm:text-sm leading-relaxed" data-id="element-236">
                  {point.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} whileHover={{
        scale: 1.02
      }} className="text-center max-w-2xl mx-auto bg-blue-50 rounded-xl sm:rounded-2xl p-4 sm:p-8 ring-1 ring-blue-200 shadow-sm cursor-pointer" data-id="element-237">
          <p className="text-sm sm:text-xl font-medium text-blue-900" data-id="element-238">
            ¿Cuántas guardias más sin un sistema que respalde cada decisión
            clínica y te blinde legalmente?
          </p>
        </motion.div>
      </div>
    </section>;
}